var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MemolifeTvView"},[_c('WidthWrapper',{attrs:{"set-vars-on-parent":""}}),_c('div',{staticClass:"section"},[_c('MixedVideosRow')],1),_c('CategoriesSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }